import React from "react";

const DiscountCars = ({ row }) => {
  return (
    <div>
      {row?.payments?.map((item, index) => (
        <div>{item.discountCars}</div>
      ))}
    </div>
  );
};

export default DiscountCars;
